
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gtlE8BVw_45__45CE_45_45oZ_45t6UsV7IIE6ZU2tcqQIR2mp3l6sMeta } from "/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexuz4dg1QXmGuSMCCBRWh5xvAa1LAfm6hTm_45t0nb8ZF1oMeta } from "/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search6iNnfp1gRd9z2yCs_Da9MtR6iw8PCSSBIflohpu8Z4QMeta } from "/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index0n9lO8JFVMeoFqDI0x7ELpTWaSBx_wgACTLuhFAotLkMeta } from "/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93FNpUycOIUy7lQu3vyVH0Dy8B8dBXivFudCA8TUnsNXYMeta } from "/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexVyPch_45xTXCwrp8n4vFboigCAx1G8zWe3ii1rz7yQN38Meta } from "/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93DFwNVWuY_45sbEZQQzP564rX5_rXKs5FRSEZRNvi1eYJQMeta } from "/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexvCcher31rieU46lH_zgCpqGIcdWME4BNqtLp40Ho_bwMeta } from "/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93X_X_45b5EzHcZ3MnQSfPxm7JqpJxZsF3mbR_9tv_45RHzKkMeta } from "/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexk0PZ4pZqJmf5SS42lbJDZ42ndLMHcXaNiq6YQED_rvEMeta } from "/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexBq5_45NPe0JElWVbBAx8usS99Hi63MV7X89Pn8LQfdsZcMeta } from "/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexVyPch_45xTXCwrp8n4vFboigCAx1G8zWe3ii1rz7yQN38Meta || {},
    component: () => import("/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexvCcher31rieU46lH_zgCpqGIcdWME4BNqtLp40Ho_bwMeta || {},
    component: () => import("/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexk0PZ4pZqJmf5SS42lbJDZ42ndLMHcXaNiq6YQED_rvEMeta || {},
    component: () => import("/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexBq5_45NPe0JElWVbBAx8usS99Hi63MV7X89Pn8LQfdsZcMeta || {},
    component: () => import("/codebuild/output/src2977165967/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]